var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({staticClass:"base-text-button",class:{ 'is-plain': _vm.plain, 'is-light': _vm.light },attrs:{"round":"","size":_vm.size,"round":_vm.round}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }